export default __webpack_public_path__ + "static/daniella-b5f9f27738367da5768a2257e075770d.png";